import React from "react";
// Limitless Imports
import FooterTitle from "../footer-title/FooterTitle";
import { useGroupResponseTimeContext } from "../../../hooks/group-response-time/GroupResponseTimeContext";
import { useTranslation } from "@limitless/common/hooks/translation/TranslationContext";
const convertMillisecondsToReadableFormat = (milliseconds, t) => {
  if (milliseconds === 0 || !milliseconds) {
    return `${"15" + " "}${t("minutes")}`;
  }
  const minute = Math.floor(milliseconds / 1000 / 60);
  let hour = 0;
  if (minute > 60) {
    hour = Math.floor(minute / 60);
    if (hour <= 1) {
      return `${hour} ${t("hour")}`;
    } else {
      return hour < 12 ? `${hour} ${t("hours")}` : `${12} ${t("hours")}`;
    }
  } else {
    if (minute < 1) {
      return `${t("{0} seconds", Math.floor(milliseconds / 1000))}`;
    } else if (minute === 1) {
      return `${minute} ${t("minute")}`;
    } else {
      return `${minute} ${t("minutes")}`;
    }
  }
};
const TimeSinceFooter = () => {
  const {
    timeSince
  } = useGroupResponseTimeContext();
  const {
    t
  } = useTranslation();
  const time = React.useMemo(() => {
    return convertMillisecondsToReadableFormat(timeSince.time, t);
  }, [timeSince, t]);
  return /*#__PURE__*/React.createElement(FooterTitle, {
    title: t("The last question took an expert {0} to answer", time),
    position: "bottom"
  });
};
export default TimeSinceFooter;